<script setup lang="ts">
import Lottie from './Lottie.vue'
import Spinner from './Spinner.vue'

defineProps<{
  title?: string
  lottieKey?: string
}>()
</script>

<template>
  <section
    data-test="full-screen-loader"
    class="fixed top-0 left-0 z-10 w-full bg-white min-h-full flex flex-col gap-vh-64 items-center justify-center"
  >
    <p v-if="title" data-test="full-screen-loader_title" class="text-h2 font-bold px-vw-96">
      {{ title }}
    </p>

    <Lottie v-if="lottieKey" :lottie-key="lottieKey" autoplay loop class="w-1/2" />
    <Spinner v-else class="h-16 w-16" />
  </section>
</template>
